function doTransition(fn: () => void) {
  if (!document.startViewTransition) {
    fn();

    return;
  }

  document.startViewTransition(fn);
}

export { doTransition };
